import styles from './AuthSpinner.module.css';

export const AuthSpinner = () => (
  <div className={styles.wrapper}>
    <div className={styles.spinner}>
      <div className={styles.ring} />
      <div className={styles.innerRing} />
      <div className={styles.core} />
      <div className={styles.centerIcon}>
        <div className={styles.lockBody}>
          <div className={styles.lockTop} />
        </div>
      </div>

      <div className={styles.orbitContainer}>
        <div className={`${styles.orb} ${styles.orbMd} ${styles.orbYellow}`} />
      </div>
      <div className={styles.orbitContainer}>
        <div
          className={`${styles.orb} ${styles.orbSm} ${styles.orbLight}`}
          style={{
            animationDelay: '0.25s',
            animationDirection: 'reverse',
            animationDuration: '1.5s',
          }}
        />
      </div>
      <div className={styles.orbitContainer}>
        <div
          className={`${styles.orb} ${styles.orbSm} ${styles.orbGlow}`}
          style={{ animationDelay: '0.5s', animationDuration: '2.5s' }}
        />
      </div>
      <div className={styles.orbitContainer}>
        <div
          className={`${styles.orb} ${styles.orbSm} ${styles.orbDark}`}
          style={{
            animationDelay: '0.75s',
            animationDirection: 'reverse',
            animationDuration: '2s',
          }}
        />
      </div>
      <div className={styles.orbitContainer}>
        <div
          className={`${styles.orb} ${styles.orbSm} ${styles.orbYellow}`}
          style={{ animationDelay: '1s', animationDuration: '3s' }}
        />
      </div>
      <div className={styles.orbitContainer}>
        <div
          className={`${styles.orb} ${styles.orbSm} ${styles.orbLight}`}
          style={{
            animationDelay: '1.25s',
            animationDirection: 'reverse',
            animationDuration: '1.8s',
          }}
        />
      </div>

      <div
        className={styles.floatParticle}
        style={{
          top: '-1rem',
          left: '-1rem',
          width: '6px',
          height: '6px',
          backgroundColor: '#facc15',
        }}
      />
      <div
        className={styles.floatParticle}
        style={{
          top: '-0.5rem',
          right: '-1.25rem',
          width: '8px',
          height: '8px',
          backgroundColor: '#fde68a',
          animationDelay: '1s',
        }}
      />
      <div
        className={styles.floatParticle}
        style={{
          bottom: '-1rem',
          right: '-0.5rem',
          width: '6px',
          height: '6px',
          backgroundColor: '#fcd34d',
          animationDelay: '2s',
        }}
      />
      <div
        className={styles.floatParticle}
        style={{
          bottom: '-0.5rem',
          left: '-1.25rem',
          width: '8px',
          height: '8px',
          backgroundColor: '#b45309',
          animationDelay: '0.5s',
        }}
      />
      <div
        className={styles.floatParticle}
        style={{
          top: '0rem',
          left: '0rem',
          width: '4px',
          height: '4px',
          backgroundColor: '#facc15',
          animationDelay: '1.5s',
        }}
      />
      <div
        className={styles.floatParticle}
        style={{
          bottom: '0rem',
          right: '0rem',
          width: '4px',
          height: '4px',
          backgroundColor: '#fde68a',
          animationDelay: '2.5s',
        }}
      />
    </div>
  </div>
);
